function create(sess, chat) {
    const { Chat } = sess;
    return Chat.create(chat);
}

function addMessage(sess, message, chatId) {
    const { Chat, ChatMessage, ForumUser } = sess;
    const chat = Chat.withId(chatId);
    const sender = ForumUser.create(message.sender);
    ChatMessage.create({
        ...message,
        chat,
        sender
    });
}

export default {
    create,
    addMessage
};
